import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { paths } from "../config/constants";

const ProtectedRoute = ({ allowedRoles }) => {
  const token = localStorage.getItem("token");

  // ✅ Get role from Redux store
const rawRole = useSelector((state) => state.login.user?.data?.role);
const accountType = useSelector((state) => state.login.user?.data?.accountType);

let role = null;

if (rawRole === "2") {
  role = accountType === "Agent" ? "Agent" : "Company";
} else if (rawRole === "2.1") {
  role = "Employee";
} else if (rawRole === "5") {
  role = "Carrier";
} else if (rawRole === "5.1") {
  role = "Driver";
} else if (rawRole === "1") {
  role = "User";
}


  // Wait for Redux to rehydrate before checking
  const isRehydrated = useSelector((state) => state._persist?.rehydrated);
  if (!isRehydrated) return null; // prevents redirect flicker

  if (!token) {
    return <Navigate to={paths.accounts.login} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to={paths.accounts.login} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
